<template>
   <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="true"
    >
      <template #layoutContent>
        <Loader>
          <Card>
            <EmployeInfoForm /> 
          </Card>
        </Loader>
      </template>
    </SubLayout>
  
</template>

<script setup>
import Card from '@/components/Card.vue';
import Loader from '@/components/Loader.vue';
import SubLayout from '@/views/Layouts/partials/SubLayout.vue';
import { ref } from 'vue';
import EmployeInfoForm from './components/EmployeInfoForm.vue';


const title = ref("breadcrumbs.folder.title")
const breadcrumbs  = ref([
  {
    name : 'folder.create',
    path : 'employe-folder-list-create'
  },
  
])


</script>

<style scoped>

</style>
